module.exports = __webpack_public_path__ + "static/media/ic_chevron-down-white.797a8766.svg";